import { ISubscriptionWellfunnel } from 'api/components/Subscriptions/types';

import { STANDARD_PERIODS } from 'constants/periods';

import { IDiscountSubscription } from 'types/subscription';

import { gridBreakpoints } from 'theme/mediaQueries';
import isTablet from './isTablet';
import isMobile from './isMobile';

export const isEmpty = (value: null | undefined | string | number | object): boolean => {
    return (
        value === null ||
        value === undefined ||
        (typeof value === 'object' && Object.keys(value).length === 0) ||
        (typeof value === 'string' && value.trim().length === 0) ||
        (typeof value === 'number' && Number(value) === Infinity)
    );
};

export const getParamFromUrl = (paramName: string) => {
    const params = new URLSearchParams(window.location.search);

    return params.get(paramName);
};

export const replaceUnderscoreToDash = (string: string): string => string.replace(/_/g, '-');

export const isProd = () => import.meta.env.ENV === 'prod';

export const uuidv4 = () => {
    const array = new Uint8Array(16);

    crypto.getRandomValues(array);

    array[6] = (array[6] & 0x0f) | 0x40; // Version 4
    array[8] = (array[8] & 0x3f) | 0x80; // Variant bits

    const hex = Array.from(array, (byte) => byte.toString(16).padStart(2, '0')).join('');

    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20, 32)}`;
};

export const roundToNearest = (number: number, multiple = 10) => Math.round(number / multiple) * multiple;

export const getValuesByKey = <T>(array: T[] | null, ...keys: (keyof any)[]): any[] => {
    if (!array || array.length === 0) return [];

    return array
        .map((item) => {
            let value: any = item;

            for (const key of keys) {
                if (value === null || value === undefined) return undefined;
                value = value[key];
            }

            return value;
        })
        .filter((value) => value !== null && value !== undefined);
};

const normalizePeriod = (period: number, tolerance: number) =>
    STANDARD_PERIODS.find((standard) => Math.abs(period - standard) <= tolerance) ?? period;

const normalizeSubscription = (subscription: IDiscountSubscription | ISubscriptionWellfunnel, tolerance = 5) => ({
    ...subscription,
    subscription_period: normalizePeriod(subscription.subscription_period, tolerance),
});

export const normalizeSubscriptionPeriods = (
    subscriptions: IDiscountSubscription[] | ISubscriptionWellfunnel[],
    tolerance = 5
) => subscriptions.map((subscription) => normalizeSubscription(subscription, tolerance));

export const reloadPage = () => window.location.reload();

export const getPathname = () => window.location.pathname;

export const getEmailDomain = (email: string | null): string | null => {
    if (!email) return null;

    const i = email.lastIndexOf('@');

    return i === -1 ? null : email.slice(i + 1).toLowerCase();
};

export const redirectTo = (url: string) => {
    window.location.href = url;
};

export const getWindowSize = (params = '(min-width: 1024px)') => {
    const mediaQuery = window.matchMedia(params);

    return mediaQuery.matches;
};

export const isTabletSize = () => getWindowSize(`(min-width: ${gridBreakpoints.tablet}px)`);

export const getDeviceType = () => {
    if (isTablet()) {
        return 'tablet';
    } else if (isMobile.any()) {
        return 'phone';
    }

    return 'desktop';
};
